"use client";

import { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import dynamic from "next/dynamic";

const ButtonSignin = dynamic(
  () => import("@/components/ButtonSignin"),
  { ssr: false }
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function HomeHeader({ user }: { user: any }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-base-100/95 border-b border-base-200/50 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <Link href="/" className="flex items-center gap-2">
            <Image
              src="/general/MMP Color Logo.png"
              alt="ChangeLyric"
              width={32}
              height={32}
              className="rounded-full object-cover"
            />
            <span className="text-xl font-bold text-base-content hidden sm:inline">
              ChangeLyric
            </span>
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-4">
            <Link href="#features" className="btn btn-ghost btn-sm">Features</Link>
            <Link href="#testimonials" className="btn btn-ghost btn-sm">Past Work</Link>
            <Link href="#about" className="btn btn-ghost btn-sm">About</Link>
            <Link href="/blog" className="btn btn-ghost btn-sm">Blog</Link>
            <Link href="#faq" className="btn btn-ghost btn-sm">FAQ</Link>
            <Link href="/pricing" className="btn btn-ghost btn-sm">Pricing</Link>
            <Link href="/service" className="btn btn-outline btn-secondary btn-sm">Done For You</Link>
            {user ? (
              <Link href="/dashboard" className="btn btn-outline btn-primary btn-sm">
                Dashboard
              </Link>
            ) : (
              <ButtonSignin text="Do It Yourself" extraStyle="btn-outline btn-primary btn-sm" />
            )}
          </nav>

          {/* Mobile Menu Button */}
          <button
            aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden btn btn-ghost btn-sm btn-square"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="lg:hidden border-t border-base-200 bg-base-100/95">
          <div className="container mx-auto px-4 py-4">
            <div className="flex flex-col gap-2">
              <Link
                href="#features"
                className="btn btn-ghost btn-sm justify-start"
                onClick={() => setMobileMenuOpen(false)}
              >
                Features
              </Link>
              <Link
                href="#testimonials"
                className="btn btn-ghost btn-sm justify-start"
                onClick={() => setMobileMenuOpen(false)}
              >
                Past Work
              </Link>
              <Link
                href="#about"
                className="btn btn-ghost btn-sm justify-start"
                onClick={() => setMobileMenuOpen(false)}
              >
                About
              </Link>
              <Link
                href="/blog"
                className="btn btn-ghost btn-sm justify-start"
                onClick={() => setMobileMenuOpen(false)}
              >
                Blog
              </Link>
              <Link
                href="#faq"
                className="btn btn-ghost btn-sm justify-start"
                onClick={() => setMobileMenuOpen(false)}
              >
                FAQ
              </Link>
              <Link
                href="/pricing"
                className="btn btn-ghost btn-sm justify-start"
                onClick={() => setMobileMenuOpen(false)}
              >
                Pricing
              </Link>
              <Link
                href="/service"
                className="btn btn-outline btn-secondary btn-sm justify-start"
                onClick={() => setMobileMenuOpen(false)}
              >
                Done For You
              </Link>
              <div className="pt-2 mt-2 border-t border-base-200">
                {user ? (
                  <Link
                    href="/dashboard"
                    className="btn btn-primary btn-sm btn-block"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Dashboard
                  </Link>
                ) : (
                  <ButtonSignin text="Sign In" extraStyle="btn-sm btn-block" />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
